import { render } from "./FooterSectionST.vue?vue&type=template&id=6ba8ee6f"
import script from "./FooterSectionST.vue?vue&type=script&lang=js"
export * from "./FooterSectionST.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__